import { createSlice } from "@reduxjs/toolkit";

export const portfolioSlice = createSlice({
  name: "portfolio",
  initialState: {
    rData: [],
    //email: '1@1.com',
  },
  reducers: {
    update: (state, action) => {
      state.rData = action.payload.rData;
      //state.email = action.payload.email;
      // console.log("Reducers update =", state, action);
    },
  },
});

export const { update } = portfolioSlice.actions;
export default portfolioSlice.reducer;
